import { useContext } from "react"
import ThemeContext, { type ThemeContextType } from "context/ThemeContext"

const useThemeContext: () => ThemeContextType = () => useContext(ThemeContext)

const useTheme = (): ThemeContextType => {
  const { theme, setTheme, variant, setVariant } = useThemeContext()

  return { theme, setTheme, variant, setVariant }
}

export default useTheme
